import { loadDomainReduxAction, PAGINATION_LIMIT_DEFAULT } from '@gymaholic/packages'
import { PROFILE_LOGS_ACTION, PROFILE_LOGS_ENDPOINT, PROFILE_LOGS_PATH } from 'modules/profile-log/redux/constants'
import REDUX_OPTION from 'modules/redux/constants/option'
import { endOfDayDateUtil, formatISODateUtil, logUtil, startOfDayDateUtil, subMonthsDateUtil } from 'packages/src'

function loadProfileLogsAction (type) {
  return async (dispatch) => {
    try {
      await dispatch(loadDomainReduxAction({
        type: PROFILE_LOGS_ACTION.LOAD,
        payload: {
          endpoint: PROFILE_LOGS_ENDPOINT.ROOT,
          domainListPath: PROFILE_LOGS_PATH.ALL,
          options: {
            [REDUX_OPTION.IGNORE_UPDATED_AT]: true
          },
          query: {
            limit: PAGINATION_LIMIT_DEFAULT,
            minCreatedAt: formatISODateUtil(startOfDayDateUtil(subMonthsDateUtil(
              new Date(),
              1
            ))),
            maxCreatedAt: formatISODateUtil(endOfDayDateUtil(new Date())),
            type
          }
        }
      }))
    } catch (error) {
      logUtil('').error('loading profileLogs failed: ', error)
    }
  }
}

export default loadProfileLogsAction
